import React from "react";

import { cn } from "@/lib/utils";

const Wrapper = ({ children, className }) => {
  return (
    <div
      className={cn(
        "flex w-full flex-col rounded-[1rem] bg-white shadow-light-sm",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Wrapper;
